import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FETCH_DOCUMENTS,
  FETCH_DOCUMENTS_SUCCESS,
  FETCH_DOCUMENTS_FAILURE,
  FetchDocumentsActionType,
  Document
} from 'src/redux/documentsReducer'
import { RootReducer } from 'src/redux/rootReducer'

interface Response {
  total_pages: number
  total_count: number
  documents: Document[]
  page: number
}

interface FetchDocumentsParams {
  page: number
  client_id?: string
  motorbike_id?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchDocumentsFlow(action: FetchDocumentsActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const currentPage = yield select((state: RootReducer) => state.documentsReducer.currentPage)
    const endpoint = '/dealers_api/documents'
    const params: FetchDocumentsParams = { page: currentPage }
    if (typeof action.payload.clientId === 'string') {
      params.client_id = action.payload.clientId
    }
    if (typeof action.payload.motorbikeId === 'string') {
      params.motorbike_id = action.payload.motorbikeId
    }
    const response: Response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params
    })
    yield put(
      FETCH_DOCUMENTS_SUCCESS({
        documents: response.documents,
        totalPages: response.total_pages,
        totalCount: response.total_count,
        page: currentPage
      })
    )
  } catch (error) {
    yield put(FETCH_DOCUMENTS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchDocumentsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_DOCUMENTS, FetchDocumentsFlow)
}
